import { render, staticRenderFns } from "./FeedbackGuide.vue?vue&type=template&id=8a70619c&scoped=true&"
import script from "./FeedbackGuide.vue?vue&type=script&lang=js&"
export * from "./FeedbackGuide.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackGuide.vue?vue&type=style&index=0&id=8a70619c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a70619c",
  null
  
)

export default component.exports